import {
  trigger,
  animate,
  transition,
  style,
  query,
  animateChild,
  group,
} from '@angular/animations';

export const routeAnimation = trigger('routeAnimation', [

  transition(':increment', [
    group([
      // Only animate leave if it wasn't swiped manually
      query('.content > router-outlet ~ :leave:not(.swiping)', [
        style({ position: 'fixed', width: '100%' }),
        animate('750ms ease-out', style({ transform: 'translate3d(-100%, 0, 0)', opacity: 1 }))
      ], { optional: true }),

      query('.content > router-outlet ~ :enter', [
        style({ position: 'fixed', width: '100%', transform: 'translate3d(100%, 0, 0)', opacity: 1 }),
        animate('750ms ease-out', style({ transform: 'translate3d(0%, 0, 0)', opacity: 1 }))
      ], { optional: true }),

      // query('@*', animateChild(), { optional: true })
    ])
  ]),

  transition(':decrement', [
    group([
      query('.content > router-outlet ~ :leave:not(.swiping)', [
        style({ position: 'fixed', width: '100%' }),
        animate('750ms ease-out', style({ transform: 'translate3d(100%, 0, 0)', opacity: 1 }))
      ], { optional: true }),

      query('.content > router-outlet ~ :enter', [
        style({ position: 'fixed', width: '100%', transform: 'translate3d(-100%, 0, 0)', opacity: 1 }),
        animate('750ms ease-out', style({ transform: 'translate3d(0%, 0, 0)', opacity: 1 }))
      ], { optional: true }),

      // query('@*', animateChild(), { optional: true })
    ])
  ])
]);

// export const routeAnimation = trigger('routeAnimation', [

//   // index Up (from right to left)
//   transition(':increment', [
//     group([
//       query(
//         'router-outlet ~ :leave:not(.swiping)',
//         [
//           style({
//             transform: 'translate3d(0%, 0px, 0px)',
//             position: 'relative',
//           }),
//           animate(
//             '{{ duration }} ease-in-out',
//             style({
//               transform: 'translate3d(-100%, 0px, 0px)',
//               position: 'relative',
//             })
//           ),
//         ]
//         , { optional: true }
//       ),
//       query(
//         'router-outlet ~ :enter',
//         [
//           style({
//             transform: 'translate3d(100%, 0px, 10px)',
//             position: 'fixed',
//           }),
//           animate(
//             '{{ duration }} ease-in-out',
//             style({
//               transform: 'translate3d(0%, 0px, 10px)',
//               position: 'fixed',
//             })
//           ),
//         ]
//         , { optional: true }
//       ),
//       query('@*', [animateChild()], {optional: true}),
//     ]),
//   ]),

//   // index Down (from left to right)
//   transition(':decrement', [
//     group([
//       query(
//         'router-outlet ~ :leave:not(.swiping)',
//         [
//           style({
//             transform: 'translate3d(0%, 0px, 0px)',
//             position: 'relative',
//           }),
//           animate(
//             '{{ duration }} ease-in-out',
//             style({
//               transform: 'translate3d(100%, 0px, 0px)',
//               position: 'relative',
//             })
//           ),
//         ]
//         , { optional: true }
//       ),
//       query(
//         'router-outlet ~ :enter',
//         [
//           style({
//             transform: 'translate3d(-100%, 0px, 10px)',
//             position: 'fixed',
//           }),
//           animate(
//             '{{ duration }} ease-in-out',
//             style({
//               transform: 'translate3d(0%, 0px, 10px)',
//               position: 'fixed',
//             })
//           ),
//         ]
//         , { optional: true }
//       ),
//       query('@*', [animateChild()], {optional: true}),
//     ]),
//   ]),
// ]);

export const slideOutAnimation = trigger('slideOutAnimation', [
  /*transition('-1 => *', [
    
      query('@*', [
          animateChild()
      ],
        { optional: true }
      )
  ]),*/

  // index Up (right)
  transition(':increment', [
    group([
      query(
        'router-outlet ~ :enter',
        [
          style({
            transform: 'translate3d(10%, {{ y }}, 0px)',
            position: 'fixed',
          }),
        ],
        { optional: true }
      ),
      query(
        'router-outlet ~ :leave',
        [
          style({ transform: 'translate3d(0%, 0px, 10px)' }),
          animate(
            '{{ duration }} ease-in-out',
            style({ transform: 'translate3d(-100%, 0px, 10px)' })
          ),
        ],
        { optional: true }
      ),
      query(
        'router-outlet ~ :enter',
        [
          style({ transform: 'translate3d(10%, {{ y }}, 0px)' }),
          animate(
            '{{ duration }} ease-in-out',
            style({ transform: 'translate3d(0%, {{ y }}, 0px)' })
          ),
        ],
        { optional: true }
      ) /*,
      query('@*', [
          animateChild()
      ],
        { optional: true }
      )*/,
    ]),
  ]),

  // index Down (left)
  transition(':decrement', [
    group([
      query(
        'router-outlet ~ :enter',
        [
          style({
            transform: 'translate3d(-100%, {{ y }}, 10px)',
            position: 'fixed',
          }),
        ],
        { optional: true }
      ),
      query(
        'router-outlet ~ :leave',
        [
          style({ transform: 'translate3d(0%, 0px, 0px)' }),
          animate(
            '{{ duration }} ease-in-out',
            style({ transform: 'translate3d(10%, 0px, 0px)' })
          ),
        ],
        { optional: true }
      ),
      query(
        'router-outlet ~ :enter',
        [
          style({ transform: 'translate3d(-100%, {{ y }}, 10px)' }),
          animate(
            '{{ duration }} ease-in-out',
            style({ transform: 'translate3d(0%, {{ y }}, 10px)' })
          ),
        ],
        { optional: true }
      ) /*,
      query('@*', [
          animateChild()
      ],
        { optional: true }
      )*/,
    ]),
  ]),
]);